import { formatDate, formatPercentage, safeParseFloat } from '@/lib/utils';
import {
  ContractCancellationDetails,
  ContractCancellationDisplayData,
} from '../types';

/**
 * Transforms raw cancellation details from the API into display-ready format.
 *
 * This function converts string values to appropriate numeric types and applies
 * formatting for currency, dates, and percentages according to the UI requirements.
 *
 * @param raw - The raw cancellation details from the API
 * @returns Transformed data ready for display in the UI
 */
export function transformCancellationData(
  raw: ContractCancellationDetails
): ContractCancellationDisplayData {
  return {
    customerRefundAmount: safeParseFloat(raw.customerRefund),
    cancelFee: safeParseFloat(raw.cancelFee),
    claimsDeducted: raw.claimsDeducted,
    claimsAmount: safeParseFloat(raw.claimsDeductedAmount),
    storeRefund: safeParseFloat(raw.storeRefund),
    cancelDate: formatDate(raw.cancelDate),
    daysUsed: formatPercentage(safeParseFloat(raw.daysUsed)),
    milesUsed: formatPercentage(safeParseFloat(raw.milesUsed)),
    contractUsed: formatPercentage(safeParseFloat(raw.cancelFactorUsed)),
    cancelReason: raw.cancelReason,
    cancelStatus: raw.cancelStatus,
    cancelMileage: raw.cancelMileage,
    payeeName: raw.payeeName,
  };
}
